import type { ImageProps } from '@chakra-ui/react'
import { forwardRef, Image } from '@chakra-ui/react'

import warningIcon from '../../images/warning-icon.svg'

export interface WarningIconProps extends ImageProps { }

export const WarningIcon = forwardRef(
  ({ sx, ...rest }: WarningIconProps, ref) => {
    return (
      <Image
        ref={ref}
        src={warningIcon}
        alt=""
        aria-hidden
        sx={{ ...sx }}
        {...rest}
      />
    )
  },
)
